import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

const industries = [
  { name: "International Trade", slug: "", img: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?auto=format&fit=crop&w=900&q=80" },
  { name: "Manufacturing", slug: "manufacturing", img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=900&q=80" },
  { name: "Construction Materials", slug: "construction-materials", img: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?auto=format&fit=crop&w=900&q=80" },
  { name: "Industrial Equipment", slug: "industrial-equipment", img: "https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0?auto=format&fit=crop&w=900&q=80" },
  { name: "Energy & Commodities", slug: "energy", img: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=900&q=80" },
  { name: "Food & Agriculture", slug: "food-agriculture", img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=900&q=80" },
  { name: "Consumer Goods", slug: "consumer-goods", img: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=900&q=80" },
  { name: "Technology & Innovation", slug: "technology", img: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=900&q=80" },
  { name: "Investment Projects", slug: "investment", img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80" },
  { name: "Logistics & Supply Chain", slug: "logistics", img: "https://images.unsplash.com/photo-1601158935942-52255782d322?auto=format&fit=crop&w=900&q=80" },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-24 md:py-32 bg-altin-ink relative overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-divider" />
            <span className="overline">Sectors</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-white tracking-tight">
            Industries{" "}
            <span className="italic text-altin-gold">we serve</span>.
          </h2>
          <p className="mt-6 text-lg text-white/70 font-light leading-relaxed max-w-2xl">
            High-value sectors where we deliver brokerage and consulting
            expertise — spanning commodity flows, manufacturing, infrastructure
            and specialised commercial partnerships.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {industries.map((it, i) => (
            <motion.div
              key={it.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: (i % 5) * 0.06 }}
            >
              <Link
                to={`/industries${it.slug ? `#${it.slug}` : ""}`}
                data-testid={`industry-chip-${i}`}
                className="group relative block overflow-hidden aspect-[3/4] border border-white/10"
              >
                <img
                  src={it.img}
                  alt={it.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-altin-ink via-altin-ink/60 to-altin-ink/10 transition-opacity duration-300 group-hover:from-altin-ink/95" />
                <div className="absolute inset-0 p-5 flex flex-col justify-between">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-altin-gold">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div>
                    <div className="font-serif-display text-xl text-white leading-tight tracking-tight">
                      {it.name}
                    </div>
                    <div className="mt-2 h-px w-8 bg-altin-gold transition-all duration-300 group-hover:w-16" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            to="/industries"
            data-testid="industries-explore-more"
            className="group inline-flex items-center gap-3 border border-altin-gold text-white px-8 py-4 text-xs tracking-[0.22em] uppercase hover:bg-altin-gold hover:text-altin-ink transition-colors duration-300"
          >
            Explore All Industries
            <ArrowRight weight="light" className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
